<template>
  <div style="height: 100%">
    <div class="equipment-pc-body">
      <div class="body">
        <div class="title">{{equipment.title}}</div>
        <div class="content">
          <div class="left">
              <div class="group-title">{{equipment.title}}</div>
              <div class="group-item" v-for="(item) in equipment.list" :key="item.group" @click="onChooseGroup(item)">
                  <div :class="selectedGroup.group != item.group ? 'group-normal' : 'group-selected'">{{item.group}}</div>
              </div>
          </div>
          <div class="right">
            <div class="right-title">{{selectedGroup.group}}</div>
            <div class="equipment" v-for="(item) in selectedGroup.datalist" :key="item.title">
              <div class="equipment-title">{{item.info}}</div>
              <img class="equipment-image" :src="'static/pic/' + item.image" v-if="item.image.length > 0"/>
              <div class="equipment-content" v-if="item.desc">{{item.desc}}</div>
            </div>
            <div class="device-list" v-if="selectedGroup.devicelist">
              <div class="device-item" v-for="(device) in selectedGroup.devicelist" :key="device.name" @click="onChooseDevice(device.groupname)">
                <img class="device-item-image" :src="'static/pic/' + device.image"/>
                <div class="device-item-name">{{device.name}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="equipment-mobile-body">
      <div class="header" @click="showMobileMenu()">{{selectedGroup.group}} <i class="el-icon-arrow-down" v-show="!isMobileMenuShow" /><i class="el-icon-arrow-up" v-show="isMobileMenuShow" /></div>
      <div v-if="isMobileMenuShow" class="header-menu">
        <div v-for="(item) in equipment.list" :key="item.group" @click="onChooseGroup(item)" class="header-menu-item">
          <div :class="selectedGroup.group != item.group ? 'group-normal' : 'group-selected'">{{item.group}}</div>
        </div>
      </div>
      <div class="equipment-body">
        <div class="title">{{equipment.title}}</div>
        <div class="content">
          <div class="equipment" v-for="(item) in selectedGroup.datalist" :key="item.title">
            <div class="equipment-title">{{item.info}}</div>
              <img class="equipment-image" :src="'static/pic/' + item.image" v-if="item.image.length > 0"/>
              <div class="equipment-content" v-if="item.desc">{{item.desc}}</div>
          </div>
          <div class="device-list" v-if="selectedGroup.devicelist">
              <div class="device-item" v-for="(device) in selectedGroup.devicelist" :key="device.name" @click="onChooseDevice(device.groupname)">
                <img class="device-item-image" :src="'static/pic/' + device.image"/>
                <div class="device-item-name">{{device.name}}</div>
              </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getCurLan} from '@/util/tools'
export default {
  name: "equipment-page",
  data() {
    return {
      isMobileMenuShow: false,
      selectedGroup: [],
      equipment: {
        title: "仪器设备",
        brief: "SF09组实验室布局一览",
        list: [
          {
            title: "迷你表面实验室（MBE-STM-HREELS-XPS/UPS-LEED联合系统",
            content:"仪器是我们实验室唯一一套商业化仪器系统。它是一个综合的表面单元子层生长-表面分析系统，包含一个分子束外延系统",
            imagelist:[
              "",
              ""
            ]
          }
        ]
      }
    }
  },
  mounted () {
    var self = this
    getCurLan().then(res => {
      self.equipment = res.equipment
      self.selectedGroup = self.equipment.list[0]
    })
    // this.equipment = getCurLan().equipment
    // this.selectedGroup = this.equipment.list[0]
  },
  methods: {
    onChooseGroup (item) {
      this.selectedGroup = item
      if (this.isMobileMenuShow) {
        this.isMobileMenuShow = false
      }
    },
    showMobileMenu () {
      this.isMobileMenuShow = !this.isMobileMenuShow
    },
    onChooseDevice (groupname) {
      var item = this.equipment.list.filter(_ => {
        return _.group === groupname
      })
      if (item.length > 0) {
        this.onChooseGroup(item[0])
      }
    }
  }
};
</script>
<style lang='scss' src='../assets/styles/pc/equipment-page.scss'></style>
<style lang='scss' src='../assets/styles/mobile/equipment-page.scss'></style>


// WEBPACK FOOTER //
// src/components/Equipment.vue